namespace TabAurous.Retail {
    export interface POSSalesWithoutTaxForm {
        TransDate: Serenity.DateEditor;
        Posted: LabelEditor;
        TransId: Serenity.StringEditor;
        VoucherNo: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        POSCustomerId: Serenity.ServiceLookupEditor;
        CustomerName: Serenity.StringEditor;
        Address: Serenity.TextAreaEditor;
        PartyId: Serenity.IntegerEditor;
        Mobile: Serenity.IntegerEditor;
        PanNumber: Serenity.StringEditor;
        BillNo: Serenity.StringEditor;
        BillDate: Serenity.DateEditor;
        ChallanNo: Serenity.StringEditor;
        ChallanDate: Serenity.DateEditor;
        BirthDate: Serenity.DateEditor;
        Anniversary: Serenity.DateEditor;
        TaxId: Serenity.StringEditor;
        CurrencyId: Serenity.LookupEditor;
        ExchRate: Serenity.DecimalEditor;
        EmployeeId: Serenity.LookupEditor;
        UserId: Serenity.LookupEditor;
        GSTState: Serenity.StringEditor;
        ImageName: Serenity.ImageUploadEditor;
        ItemDetails: POSSalesWithoutTaxItemsEditor;
        GiftDetails: POSSalesGiftVoucherEditor;
        PromoDetails: PosSalesPromoEditor;
        ReceiptDetails: POSSalesReceiptEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        Discount: Serenity.DecimalEditor;
        AdditionalCharges: Serenity.DecimalEditor;
        RoundOff: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        Receipt: Serenity.DecimalEditor;
        BalanceAmount: Serenity.DecimalEditor;
        Remark: Serenity.TextAreaEditor;
        ShipAddressId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
        CompanyId: Serenity.IntegerEditor;
    }

    export class POSSalesWithoutTaxForm extends Serenity.PrefixedContext {
        static formKey = 'Retail.POSSalesWithoutTax';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!POSSalesWithoutTaxForm.init)  {
                POSSalesWithoutTaxForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = LabelEditor;
                var w2 = s.StringEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.ServiceLookupEditor;
                var w5 = s.TextAreaEditor;
                var w6 = s.LookupEditor;
                var w7 = s.DecimalEditor;
                var w8 = s.ImageUploadEditor;
                var w9 = POSSalesWithoutTaxItemsEditor;
                var w10 = POSSalesGiftVoucherEditor;
                var w11 = PosSalesPromoEditor;
                var w12 = POSSalesReceiptEditor;

                Q.initFormType(POSSalesWithoutTaxForm, [
                    'TransDate', w0,
                    'Posted', w1,
                    'TransId', w2,
                    'VoucherNo', w2,
                    'VoucherTypeId', w3,
                    'POSCustomerId', w4,
                    'CustomerName', w2,
                    'Address', w5,
                    'PartyId', w3,
                    'Mobile', w3,
                    'PanNumber', w2,
                    'BillNo', w2,
                    'BillDate', w0,
                    'ChallanNo', w2,
                    'ChallanDate', w0,
                    'BirthDate', w0,
                    'Anniversary', w0,
                    'TaxId', w2,
                    'CurrencyId', w6,
                    'ExchRate', w7,
                    'EmployeeId', w6,
                    'UserId', w6,
                    'GSTState', w2,
                    'ImageName', w8,
                    'ItemDetails', w9,
                    'GiftDetails', w10,
                    'PromoDetails', w11,
                    'ReceiptDetails', w12,
                    'Pieces', w3,
                    'Weight', w7,
                    'NetWeight', w7,
                    'NetAmount', w7,
                    'Discount', w7,
                    'AdditionalCharges', w7,
                    'RoundOff', w7,
                    'GrossAmount', w7,
                    'Receipt', w7,
                    'BalanceAmount', w7,
                    'Remark', w5,
                    'ShipAddressId', w3,
                    'FinancialYearId', w3,
                    'CompanyId', w3
                ]);
            }
        }
    }
}
